import { createContext } from "react";
import type { Status } from "types/Status";

const WorkoutsStatusContext = createContext<Status | undefined>(undefined);
WorkoutsStatusContext.displayName = "WorkoutsStatusContext";

export default WorkoutsStatusContext;
